import { makeAutoObservable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'
import PPSlide from './Slide'

export default class PPSection {
    id = uuidv4()

    slide = []

    constructor(props) {
        if (Array.isArray(props.slide)) {
            this.slide = props.slide.map((s) => new PPSlide(s))
        }

        makeAutoObservable(this)
    }

    addSlide = (slide, activeSlide, position) => {
        if (position === 'above') {
            this.slide.splice(activeSlide, 0, new PPSlide(slide, this.store))
        } else {
            this.slide.splice(activeSlide + 1, 0, new PPSlide(slide, this.store))
        }
    }

    deleteSlide = (index) => {
        this.slide.splice(index, 1)
    }

    moveSlide = (from, to) => {
        const [slide] = this.slide.splice(from, 1)
        this.slide.splice(to, 0, slide)
    }

    toJSON = () => ({
        id: this.id,
        slide: this.slide.slice(),
    })
}
